import {
  CREATE_BUSINESS_MANAGEMENT,
  CREATE_BUSINESS_MANAGEMENT_FAILURE,
  CREATE_BUSINESS_MANAGEMENT_SUCCESS,
  EMPTY_FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION,
  FETCH_ALL_BUSINESS_MANAGEMENT_SUCCESS,
  FETCH_BUSINESS_MANAGEMENT_BY_ID_SUCCESS,
  FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS,
  FETCH_TOTAL_BUSINESS_MANAGEMENT_SUCCESS,
  RESTORE_BUSINESS_INITIAL,
  UPDATE_BUSINESS_MANAGEMENT_SUCCESS,
  UPDATE_BUSINESS_MANAGEMENT_FAILURE
} from "../ActionTypes";

const INIT_STATE = {
  businessManagementData: [],
  tablePaginationData: {},
  isLoading: true,
  businessCreated: false,
  businessIsCreating: false,
  businessUpdated: false,
  loadingUpdated: true,
  businessManagementDataNoPagination: [],
  isFetched: false,
  totalBusinessMgt: {},
  businessDetailsbyId: {},
};

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_BUSINESS_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        businessManagementData: action.payload.data,
        tablePaginationData: action.payload.meta,
        isLoading: false,
      };
    }
    case CREATE_BUSINESS_MANAGEMENT: {
      return {
        ...state,
        businessCreated: false,
        businessIsCreating: true,
      };
    }
    case CREATE_BUSINESS_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        businessCreated: true,
        businessIsCreating: false,
      };
    }
    case CREATE_BUSINESS_MANAGEMENT_FAILURE: {
      return {
        ...state,
        businessCreated: false,
        businessIsCreating: false,
      };
    }
    case RESTORE_BUSINESS_INITIAL: {
      return {
        ...state,
        businessCreated: false,
        businessUpdated: false,
        loadingUpdated: true,
        isFetched: false,
        businessDetailsbyId: {},
      }
    }
    case UPDATE_BUSINESS_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        businessUpdated: true,
        loadingUpdated: false,
      }
    }
    
    case UPDATE_BUSINESS_MANAGEMENT_FAILURE: {
      return {
        ...state,
        loadingUpdated: false,
        businessUpdated: false
      }
    }
    case FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS: {
      return {
        ...state,
        businessManagementDataNoPagination: action.payload,
        isFetched: true,
      }
    }
    case EMPTY_FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION: {
      return {
        ...state,
        businessManagementDataNoPagination: [],
      }
    }
    case FETCH_TOTAL_BUSINESS_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        totalBusinessMgt: action.payload,
      }
    }
    case FETCH_BUSINESS_MANAGEMENT_BY_ID_SUCCESS: {
      return {
        ...state,
        businessDetailsbyId: action.payload,
      }
    }

    default:
      return state;
  }
}

export default reducers;
